module.exports = __webpack_public_path__ + "media/images/form-status-completed-19e4be58.gif";